import { useRouter } from 'next/router';

import { QUERY_PARAMS } from 'constants/queryNames';

import { FormStepId } from 'shared/config/formStepId';

export const useFormStepIdFromQuery = () => {
  const router = useRouter();
  const { query } = router;
  const queryFormStepId = query[QUERY_PARAMS.FORM_STEP_ID] as string | undefined;

  if (queryFormStepId && Object.values(FormStepId).includes(queryFormStepId as FormStepId)) {
    return queryFormStepId as FormStepId;
  }

  return undefined;
};
